import React from "react";
import { useTranslation } from "react-i18next";
import {
  Box,
  ButtonStyled,
  HeadingStyled,
  LazyImage,
  TextStyled,
} from "../../../styled/Elements";
import { Col, Modal, Row } from "react-bootstrap";
import styled from "styled-components";
import { RequestCancelImg } from "../../../styled/AllImages";

const RequestModal = ({ show, onHide, handleRequest, isLoading, title }) => {
  const { t } = useTranslation();
  return (
    <Modal show={show} onHide={onHide} centered>
      <RequestModalWrapper>
        <Box className="p-4">
          <Row className="mb-2 mt-4">
            <Col lg={5} sm={12}>
              <Box className="d-flex align-items-center justify-content-center">
                <LazyImage src={RequestCancelImg} />
              </Box>
            </Col>
            <Col lg={7} sm={12}>
              <Box>
                <HeadingStyled size="24px" weight="bold" color="var(--text)">
                  {t("AccessDenied")}
                </HeadingStyled>
                <TextStyled size="16px" color="var(--text2)">
                  {t("YounotaccessFile", {item: t(title)})}
                </TextStyled>
              </Box>
            </Col>
          </Row>
          <Box className="d-flex justify-content-end">
            <Box className="mt-4 d-flex gap-3">
              <ButtonStyled
                label={t("Cancel")}
                bg={"var(--bgSecondary)"}
                color={"var(--text2)"}
                onClick={onHide}
              />
              <ButtonStyled
                onClick={handleRequest}
                label={t("SendRequest")}
                isLoading={isLoading}
              />
            </Box>
          </Box>
        </Box>
      </RequestModalWrapper>
    </Modal>
  );
};

export default RequestModal;

export const RequestModalWrapper = styled.div``;
